// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/ABCWhyteInktrap-Book.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "WhyteInktrap";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}
* {
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
}

html, body {
  color: #222228;
}

.Table_tableContainer__MwiFG {
  border: 1px solid #EAECF0;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.Table_tableContainer__MwiFG .Table_tr__\\+Wv3U {
  display: flex;
  border-bottom: 1px solid #EAECF0;
  align-items: center;
  background-color: #DDEAFB;
}
.Table_tableContainer__MwiFG .Table_tr__\\+Wv3U:last-child {
  border-bottom: none;
}
.Table_tableContainer__MwiFG .Table_th__XnQjq,
.Table_tableContainer__MwiFG .Table_td__pf-Q9 {
  display: flex;
  height: 44px;
  align-items: center;
  padding: 0 16px;
  font-size: 14px;
  overflow-x: hidden;
}
.Table_tableContainer__MwiFG .Table_th__XnQjq:not(:last-child),
.Table_tableContainer__MwiFG .Table_td__pf-Q9:not(:last-child) {
  border-right: 1px solid #EAECF0;
}
.Table_tableContainer__MwiFG .Table_th__XnQjq:first-child,
.Table_tableContainer__MwiFG .Table_td__pf-Q9:first-child {
  font-weight: 500;
}
.Table_tableContainer__MwiFG .Table_th__XnQjq {
  font-weight: 500;
  position: relative;
}
.Table_tableContainer__MwiFG .Table_th__XnQjq .Table_resizer__V-xZs {
  position: absolute;
  opacity: 0;
  top: 0;
  right: 0;
  height: 100%;
  width: 3px;
  background-color: #60748E;
  cursor: col-resize;
  border-radius: 6px;
}
.Table_tableContainer__MwiFG .Table_th__XnQjq .Table_resizer__V-xZs:hover {
  opacity: 1;
}
.Table_tableContainer__MwiFG .Table_th__XnQjq .Table_resizer__V-xZs.Table_isResizing__2N6vN {
  background-color: #D7B7FF;
}
.Table_tableContainer__MwiFG .Table_td__pf-Q9 {
  background-color: #FFFFFF;
  cursor: pointer;
}
.Table_tableContainer__MwiFG .Table_td__pf-Q9.Table_selectedRow__LrZCc {
  background-color: #60748E;
  color: #FFFFFF;
}
.Table_tableContainer__MwiFG .Table_td__pf-Q9.Table_centeredData__7tgOM {
  display: flex;
  align-items: center;
  justify-content: center;
}
.Table_tableContainer__MwiFG .Table_td__pf-Q9 .Table_statusCell__noOp- {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  min-width: 88px;
  border-radius: 15px;
  padding: 0 8px;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 600;
}
.Table_tableContainer__MwiFG .Table_td__pf-Q9 .Table_statusCell__noOp-.Table_openStatus__b43Uw {
  background-color: #B4E1FA;
  color: #23A0E5;
}
.Table_tableContainer__MwiFG .Table_td__pf-Q9 .Table_statusCell__noOp-.Table_inProgressStatus__ahwFE {
  background-color: rgba(250, 182, 145, 0.76);
  color: #FF7427;
}
.Table_tableContainer__MwiFG .Table_td__pf-Q9 .Table_statusCell__noOp-.Table_resolvedStatus__u2-IO {
  background-color: #7ADDAF;
  color: #007940;
}
.Table_tableContainer__MwiFG .Table_td__pf-Q9.Table_selectedRow__LrZCc {
  background-color: #60748E;
  color: #FFFFFF;
}`, "",{"version":3,"sources":["webpack://./src/core/styles.scss","webpack://./src/components/Table/Table.module.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,+DAAA;ACCF;AD0BA;EACE,sBAAA;EACA,gCAzBS;ACCX;;AD2BA;EACE,cAVY;ACdd;;AATA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAYF;AAVE;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,yBDHQ;ACeZ;AAVI;EACE,mBAAA;AAYN;AARE;;EAEE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAUJ;AARI;;EACE,+BAAA;AAWN;AARI;;EACE,gBAAA;AAWN;AAPE;EACE,gBAAA;EACA,kBAAA;AASJ;AAPI;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,yBDpCK;ECqCL,kBAAA;EACA,kBAAA;AASN;AAPM;EACE,UAAA;AASR;AANM;EACE,yBDpCC;AC4CT;AAHE;EACE,yBDrCI;ECsCJ,eAAA;AAKJ;AAHI;EACE,yBDvDK;ECwDL,cD1CE;AC+CR;AAFI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAIN;AADI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAGN;AADM;EACE,yBDhFK;ECiFL,cDhFD;ACmFP;AAAM;EACE,2CDjFM;ECkFN,cDjFC;ACmFT;AACM;EACE,yBDlFK;ECmFL,cDlFA;ACmFR;AAGI;EACE,yBD9FK;EC+FL,cDjFE;ACgFR","sourcesContent":["@font-face {\n  font-family: 'WhyteInktrap';\n  src: url('./../assets/fonts/ABCWhyteInktrap-Book.otf') format('opentype');\n}\n\n//FONTS\n$mainFont: 'Inter', sans-serif;\n$secondaryFont: 'WhyteInktrap', sans-serif;\n\n// COLORS\n$lightBlue: #DDEAFB;\n$mediumBlue: #B4E1FA;\n$blue: #23A0E5;\n$darkBlue: #60748E;\n$lightGrey: #EAECF0;\n$lightOrange: rgba(250, 182, 145, 0.76);\n$orange: #FF7427;\n$red: #C60C30;\n$plusGreen: #EBFF99;\n$lightGreen: #7ADDAF;\n$green: #007940;\n$darkGreen: #112C22;\n$purple: #D7B7FF;\n$lightPurple: #DBD7FC;\n\n$primaryDark: #222228;\n$secondaryDark: #122D62;\n$white: #FFFFFF;\n\n* {\n  box-sizing: border-box;\n  font-family: $mainFont;\n}\n\nhtml, body {\n  color: $primaryDark;\n}","@import '../../core/styles';\n\n.tableContainer {\n  border: 1px solid $lightGrey;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  .tr {\n    display: flex;\n    border-bottom: 1px solid $lightGrey;\n    align-items: center;\n    background-color: $lightBlue;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  .th,\n  .td {\n    display: flex;\n    height: 44px;\n    align-items: center;\n    padding: 0 16px;\n    font-size: 14px;\n    overflow-x: hidden;\n\n    &:not(:last-child) {\n      border-right: 1px solid $lightGrey;\n    }\n\n    &:first-child {\n      font-weight: 500;\n    }\n  }\n\n  .th {\n    font-weight: 500;\n    position: relative;\n\n    .resizer {\n      position: absolute;\n      opacity: 0;\n      top: 0;\n      right: 0;\n      height: 100%;\n      width: 3px;\n      background-color: $darkBlue;\n      cursor: col-resize;\n      border-radius: 6px;\n\n      &:hover {\n        opacity: 1;\n      }\n\n      &.isResizing {\n        background-color: $purple;\n      }\n    }\n  }\n\n  .td {\n    background-color: $white;\n    cursor: pointer;\n\n    &.selectedRow {\n      background-color: $darkBlue;\n      color: $white;\n    }\n\n    &.centeredData {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .statusCell {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 22px;\n      min-width: 88px;\n      border-radius: 15px;\n      padding: 0 8px;\n      font-size: 10px;\n      text-transform: uppercase;\n      font-weight: 600;\n\n      &.openStatus {\n        background-color: $mediumBlue;\n        color: $blue;\n      }\n\n      &.inProgressStatus {\n        background-color: $lightOrange;\n        color: $orange;\n      }\n\n      &.resolvedStatus {\n        background-color: $lightGreen;\n        color: $green;\n      }\n    }\n\n    &.selectedRow {\n      background-color: $darkBlue;\n      color: $white;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `Table_tableContainer__MwiFG`,
	"tr": `Table_tr__+Wv3U`,
	"th": `Table_th__XnQjq`,
	"td": `Table_td__pf-Q9`,
	"resizer": `Table_resizer__V-xZs`,
	"isResizing": `Table_isResizing__2N6vN`,
	"selectedRow": `Table_selectedRow__LrZCc`,
	"centeredData": `Table_centeredData__7tgOM`,
	"statusCell": `Table_statusCell__noOp-`,
	"openStatus": `Table_openStatus__b43Uw`,
	"inProgressStatus": `Table_inProgressStatus__ahwFE`,
	"resolvedStatus": `Table_resolvedStatus__u2-IO`
};
export default ___CSS_LOADER_EXPORT___;
